import {Component, OnInit} from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
    selector: 'app-admissionform',
    templateUrl: './admissionform.component.html',
    styleUrls: ['./admissionform.component.scss']
})
export class AdmissionformComponent implements OnInit {

    constructor(
        private meta: Meta,
        private titles: Title
    ) {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('ARNI Admission Form: Apply for Your Future Today');
        this.meta.updateTag({
            name: 'description',
            content: `Fill out the ARNI Admission Form to begin your academic journey. Easily apply online and take the first step towards joining our vibrant community.`
        });
    }

}
